export const kitchenLayouts: Record<string, string> = {
	Linear: 'linear',
	LShaped: 'l-shaped',
	Galley: 'galley',
	UShaped: 'u-shaped',
	Custom: 'custom'
};
